<template>
    <el-card class='box-card'>
        <div class='fs-14'>
            <div class='title fc-theme fs-16'>使用注意点：</div>
            <div class='content fs-12 fc-666'>
                1、输入抖店商品链接，生成抖音商城推荐二维码
                <br>2、将二维码截图发给你的S手，让S手用抖音扫码直接下单支付，不需要做多余的动作，也不要用微信扫码后跳转，目前测试过，不是垃圾账号基本都能出销量。可以用来破零，拉坑产都没问题。
                <br>3、该功能仅提供快速卡榜单入口，提高渠道入口权重，建议S单使用的话使用优质的账号，使用前可先<span class='fc-blue point' @click="$router.push('/vip')">使用抖音验号功能进行验号</span>，提高安全性。
                <br>4、接口合作请加微信{{getkfWx()}}
            </div>
        </div>

    </el-card>
</template>

<script>
export default {
    props: {
        info: {
            type: Object,
            default() {
                return {}
            }
        }
    },
    computed: {
        pricePreMonth() {
            return this.info;
        }
    }
}
</script>

<style scoped>

</style>
